/* global gsap */

export default class MouseNext {
	constructor(el = null) {
		if (!el) return;
		this.mousePointer = el;

		if (!this.mousePointer) return;
		this.wrapper = this.mousePointer.closest('.mouse-next-container') || false;
		this.slider = this.mousePointer.nextElementSibling || false;

		this.offsetX = this.mousePointer.getBoundingClientRect().width / 2;
		this.offsetY = this.mousePointer.getBoundingClientRect().height / 2;

		this.init();
		this.events();
	}

	moveCursor(ev) {
		gsap.to(this.mousePointer, { duration: 0.3, opacity: 1, scale: 1 });
		this.positionCircle.bind(this, ev)();
	}

	mouseEnter(ev) {
		gsap.to(this.mousePointer, { duration: 0.3, opacity: 1, scale: 1 });
		this.positionCircle.bind(this, ev)();
	}

	mouseLeave(ev) {
		gsap.to(this.mousePointer, { duration: 0.3, opacity: 0, scale: 0.2 });
	}

	positionCircle(ev) {
		const bannerRect = this.wrapper.getBoundingClientRect();
		const relX = ev.x - bannerRect.x - this.offsetX;
		const relY = ev.y - bannerRect.y - this.offsetY;
		gsap.to(this.mousePointer, { duration: 0.6, x: relX, y: relY });
	}

	init() {
		gsap.set(this.mousePointer, { scale: 0 });
	}

	events() {
		if (this.slider) {
			this.slider.addEventListener(
				'mouseenter',
				this.mouseEnter.bind(this),
				false
			);

			this.slider.addEventListener(
				'mousemove',
				this.moveCursor.bind(this),
				false
			);

			this.slider.addEventListener(
				'mouseleave',
				this.mouseLeave.bind(this),
				false
			);
		}
	}
}
